<template>
  <div
    style="font-size: 8px;"
    class="slot p-2 shadow-md rounded-md flex flex-col "
  >
    <div class="flex justify-between items-center">
      <span>Proteins</span>
      <ProgressBar
        style="max-width: 70px;"
        :value="mealsSummary.proteins.current"
        :max="mealsSummary.proteins.goal"
        class="h-2.5"
      />
    </div>
    <div class="flex justify-between items-center">
      <span>Fats</span>
      <ProgressBar
        style="max-width: 70px;"
        :value="mealsSummary.fats.current"
        :max="mealsSummary.fats.goal"
        class="h-2.5"
      />
    </div>
    <div class="flex justify-between items-center">
      <span>Carbohydrates</span>
      <ProgressBar
        style="max-width: 70px;"
        :value="mealsSummary.carbohydrates.current"
        :max="mealsSummary.carbohydrates.goal"
        class="h-2.5"
      />
    </div>
    <div class="flex justify-between items-center">
      <span>Calories</span>
      <ProgressBar
        style="max-width: 70px;"
        :value="mealsSummary.calories.current"
        :max="mealsSummary.calories.goal"
        class="h-2.5"
        :text="
          `${mealsSummary.calories.current} / ${mealsSummary.calories.goal} kcal`
        "
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "MealsSummary",
  components: {},
  props: {
    mealsSummary: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  data() {
    return {
      import_to_file: ""
    };
  },
  created() {}
};
</script>

<style></style>
